import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API from "../api/api";
import { setAuth } from "../utils/auth";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import AuthShell from "../components/AuthShell";

const Login = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await API.post("/users/auth/login", { email, password });

      setAuth(response.data.token, response.data.user);

      if (onLoginSuccess) {
        onLoginSuccess();
      }
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || "Login failed. Check your credentials");
    }
  };

  return (
    <AuthShell title="Welcome back" subtitle="Login to your Visa Portal account">
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleLogin}>
        <div className="mb-3">
          <label htmlFor="email" className="form-label fw-semibold">
            Email
          </label>
          <input
            type="email"
            id="email"
            className="form-control form-control-lg"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="mb-3 position-relative">
          <label htmlFor="password" className="form-label fw-semibold">
            Password
          </label>
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            className="form-control form-control-lg"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="button"
            className="btn btn-link position-absolute end-0 translate-middle-y p-0 me-3"
            style={{ top: "70%", color: "var(--vp-text-muted)" }}
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        <button type="submit" className="btn btn-primary btn-lg w-100 rounded-pill">
          Login
        </button>
      </form>

      <p className="auth-footer-links">
        Don&apos;t have an account? <Link to="/register">Sign up</Link>
      </p>
      <p className="auth-meta-links">
        <Link to="/privacy-policy">Privacy Policy</Link>
      </p>
    </AuthShell>
  );
};

export default Login;
